import React from "react";
import "./CountryCard.css";
import { Link } from "react-router-dom";

const CountryCard = ({
  flag,
  alpha3Code,
  name,
  population,
  region,
  capital,
}) => {
  
  return (
    <div className="card" id="country__card">
      <Link to={`/country-details/name/${name}`}>
        <div className="card-img-top">
          <img src={flag} alt={alpha3Code} className="card-img-top" />
        </div>
        <div className="card-body">
          <h5 className="card-title fw-bold my-3">{name}</h5>
          <p>
            <strong>Population:</strong>
            <span>{population}</span>
          </p>
          <p>
            <strong>Region:</strong>
            <span>{region}</span>
          </p>
          <p>
            <strong>Capital:</strong>
            <span>{capital}</span>
          </p>
        </div>
      </Link>
    </div>
  );
};

export default CountryCard;
